import { Col, Modal, Row } from "react-bootstrap";
import { ListContainer } from "./table/components/AssignedEntitiesModal";
import { ActionIconContainer } from "./TableElements";
import { useTranslation } from "react-i18next";
import { colorBorder } from "../../utils/palette";

export const LinkedSmallEquipmentPopup = ({
  showPopup,
  setShowPopup,
  linkedSE,
}) => {
  const { t } = useTranslation("common");
  return (
    <Modal show={showPopup} onHide={() => setShowPopup(false)} size="md">
      <Modal.Header>
        <h4>{t("linked_se")}</h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={() => setShowPopup(false)}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>

      <Modal.Body>
        <ListContainer>
          {linkedSE.map((item, i) => (
            <Row
              key={i}
              style={{
                //borderBottom: `1px solid ${colorBorder}`,
                padding: "0.75rem 0.5rem",
              }}
            >
              <Col>
                <div className="d-flex gap-2 align-items-center">
                  <img
                    src={item.imageUrl}
                    alt="vehicle-img"
                    style={{
                      width: "32px",
                      height: "32px",
                      objectFit: "cover",
                      border: `1px solid #009BD9`,
                      background: "#D4E5F6",
                      padding: "2px",
                    }}
                    className="rounded-circle"
                  />
                  <p>{item.name}</p>
                </div>
              </Col>
            </Row>
          ))}
        </ListContainer>
      </Modal.Body>

      {/* <Modal.Footer>
        <AddFormButton
          id="ok-button"
          type="button"
          onClick={() => setShowPopup(false)}
        >
          {t("ok")}
        </AddFormButton>
      </Modal.Footer> */}
    </Modal>
  );
};

export default LinkedSmallEquipmentPopup;
